"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyTreeL1CategoryDropdown = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const react_redux_1 = require("react-redux");
const strategy_tree_styles_1 = require("./strategy-tree.styles");
const hooks_1 = require("../../strategy-matrix/client/hooks");
const use_get_search_l1_categories_and_terminal_nodes_hook_1 = require("../../strategy-matrix/client/hooks/use-get-search-l1-categories-and-terminal-nodes.hook");
const attributes_matrix_selector_styles_1 = require("../../strategy-matrix/components/attributes-matrix-selector/attributes-matrix-selector.styles");
const grouped_multi_select_menu_1 = require("../../generic/grouped-multi-select-menu");
const grouped_multi_select_menu_styles_1 = require("../../generic/grouped-multi-select-menu/grouped-multi-select-menu.styles");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const StrategyTreeL1CategoryDropdown = ({ selectedCategories, selectedCatalogId, onSelect, productTreeRootNodeId, selectedProductTreeId, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { showEmptyNodes, showStrategyChanges } = (0, store_1.useProductTreeFilters)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const { data: defaultData, isLoading: defaultLoading } = (0, hooks_1.useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix)({
        productTreeNodeId: productTreeRootNodeId,
        catalogId: selectedCatalogId,
        options: {
            skip: !productTreeRootNodeId || !anchorEl,
            fetchPolicy: 'network-only',
        },
    });
    const { data: searchedData, isLoading: searchedLoading, error: searchError, } = (0, use_get_search_l1_categories_and_terminal_nodes_hook_1.useSearchL1CategoriesAndTerminalNodesForStrategyMatrix)({
        productTreeId: selectedProductTreeId,
        searchTerm: searchTerm || '',
    });
    const groupedOptions = (0, react_1.useMemo)(() => defaultData.map(({ title, id, descendants }) => ({
        label: title,
        value: id,
        children: descendants.edges.map(({ node: { descendant: { title: descendantTitle, id: descendantId } } }) => ({
            label: descendantTitle,
            value: descendantId,
        })),
    })), [defaultData]);
    const hasSearchResults = !!searchTerm && !searchError;
    const finalData = hasSearchResults ? searchedData : groupedOptions;
    const initialExpandedParentId = hasSearchResults ? (_a = finalData[0]) === null || _a === void 0 ? void 0 : _a.value : undefined;
    const categoriesIsLoading = defaultLoading || searchedLoading;
    const handleApply = (selected) => {
        onSelect(selected);
        setAnchorEl(null);
        setSearchTerm('');
    };
    const handleSearch = (search) => {
        setSearchTerm(search);
    };
    const toggleNodesWithChanges = (0, react_1.useCallback)((e) => dispatch((0, store_1.enrichAISetProductTreeFilters)({ showStrategyChanges: e.target.checked })), [dispatch]);
    const toggleFilterEmptyNodes = (0, react_1.useCallback)((e) => dispatch((0, store_1.enrichAISetProductTreeFilters)({ showEmptyNodes: e.target.checked })), [dispatch]);
    const additionalControls = (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(grouped_multi_select_menu_styles_1.StyledFormControlLabelGroupedMenu, { control: react_1.default.createElement(ui_components_1.Switch, { size: "small", checked: showStrategyChanges, onChange: toggleNodesWithChanges }), label: react_1.default.createElement(ui_components_1.Typography, { variant: "body2", accent: true }, t({ key: 'CHANGES_ONLY' })) }), react_1.default.createElement(grouped_multi_select_menu_styles_1.StyledFormControlLabelGroupedMenu, { control: react_1.default.createElement(ui_components_1.Switch, { size: "small", checked: showEmptyNodes, onChange: toggleFilterEmptyNodes }), label: react_1.default.createElement(ui_components_1.Typography, { variant: "body2", accent: true }, t({ key: 'SHOW_EMPTY_CATEGORIES' })) })));
    const isOpen = !!anchorEl;
    return (react_1.default.createElement(attributes_matrix_selector_styles_1.StyledAttributeSection, null, react_1.default.createElement(strategy_tree_styles_1.StyledFilterButton, { size: "small", className: (0, classnames_1.default)({ 'menu--open': isOpen }), endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: 'filter' }), onClick: (event) => setAnchorEl(event.currentTarget) }), react_1.default.createElement(grouped_multi_select_menu_1.GroupedMultiSelectMenu, { anchorEl: anchorEl, isLoading: categoriesIsLoading, groupedOptions: finalData, initialExpandedParentId: initialExpandedParentId, selected: selectedCategories, onApply: handleApply, onClose: () => {
            setAnchorEl(null);
            setSearchTerm('');
        }, onSearch: handleSearch, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, optimizePayload: true, additionalControls: additionalControls })));
};
exports.StrategyTreeL1CategoryDropdown = StrategyTreeL1CategoryDropdown;
exports.default = exports.StrategyTreeL1CategoryDropdown;
